.stage {
  position: relative;
  overflow: hidden;
  background: #0b0c14;
  /* Required, or a drag scrolls the page instead of moving the board. */
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;

  /* Mobile: a fixed-height well under the header. 436px at the handoff's 874px-tall
     device, shrinking on shorter screens rather than pushing the sheet off. */
  flex: none;
  width: 100%;
  height: min(436px, 52vh);
  box-shadow: inset 0 0 0 1px rgb(233 233 237 / 0.07);
}

.picture {
  position: absolute;
  display: block;
  max-width: none;
  pointer-events: none;
}

@media (min-width: 900px) {
  .stage {
    /* Desktop: fills the canvas well up to the handoff's 880x616, centred. The exact
       aspect ratio is allowed to vary with the viewport — the board is stored in image
       space (ADR-0011), so a differently-shaped stage does not move it. */
    width: 100%;
    height: 100%;
    max-width: 880px;
    max-height: 616px;
    border-radius: 10px;
    box-shadow:
      0 0 0 1px var(--color-neutral-800),
      0 20px 50px rgb(0 0 0 / 0.55);
  }
}
